import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import QRCode from 'qrcode.react';
import './ageProofUI.css';
import KycFlow from '../../kycQr';
import data from "../../api";
import Navbar from '../../Navbar';
import Login from '../../Login';
import forge from 'node-forge';



const {
    listenForUserData
} = data;

const AgeProofForm = () => {
    const [dob, setDob] = useState('');
    const [name, setName] = useState('');
    const [earthId, setEarthId] = useState('');
    const [did, setDid] = useState('');
    const [publicKey, setPublicKey] = useState('');
    const [vcUrl, setVcUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false); // ✅ login status

    const isMounted = useRef(true);

    const ssiBaseUrl = "https://ssi-test.myearth.id/api";
    const authorizationKey = "01a41742-aa8e-4dd6-8c71-d577ac7d463c";

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    if(publicKey){
        console.log('This is publickKey:', publicKey)
    }
   
    const encryptWithBase64PublicKey = (base64Key, data) => {
        try {
          // Decode base64 to binary DER
          const der = forge.util.decode64(base64Key);
          const asn1 = forge.asn1.fromDer(der);
          const publicKey = forge.pki.publicKeyFromAsn1(asn1);
      
          // Encrypt the data
          const encrypted = publicKey.encrypt(data, 'RSA-OAEP', {
            md: forge.md.sha256.create()
          });
      
          return forge.util.encode64(encrypted); // base64 encrypted output
        } catch (e) {
          console.error('Encryption error:', e);
          return null;
        }
      };

    const handleLoginFlowComplete = () => {
        listenForUserData(async (err, res) => {
            const bytes = res.userDetails || res.newreq;
            console.log("Login success. Extracted bytes:", bytes);

            setDid(bytes.userDid || '');
            let rawBase64Key = bytes.publicKey || ''; // this is like 'MA+VJL...'

    // ❗ THIS IS FAKE - You need to get a full PEM key instead of this
    const pem = `-----BEGIN PUBLIC KEY-----\n${rawBase64Key.match(/.{1,64}/g).join('\n')}\n-----END PUBLIC KEY-----`;

    setPublicKey(pem);
            setEarthId(bytes.earthId || '');
            setIsLoggedIn(true); // ✅ set flag

            console.log('These are the flags:', earthId, did, publicKey, isLoggedIn)
        });
    };

    // const generateAgeProof = async (userDOB, userName) => {
    //     const data = {
    //         schemaName: 'UserAgeSchema:1',
    //         isEncrypted: false,
    //         dependantVerifiableCredential: [],
    //         credentialSubject: {
    //             earthId,
    //             dateOfBirth: userDOB
    //         },
    //     };

    //     const config = {
    //         method: 'post',
    //         url: `${ssiBaseUrl}/issuer/verifiableCredential`,
    //         headers: {
    //             'X-API-KEY': authorizationKey,
    //             did,
    //             publicKey,
    //             'Content-Type': 'application/json',
    //         },
    //         data: JSON.stringify(data),
    //     };

    //     const response = await axios.request(config);
    //     return response.data.data.verifiableCredential;
    // };

    const generateAgeCertificate = async () => {
        console.log('Calling age certificate')
       

      //  const pem = convertBase64ToPem(publicKey); // convert base64 to PEM
      //  console.log('this is pem key:', pem)
       // const encryptedName = encryptWithBase64PublicKey(publicKey, name);
      //  const encryptedDob = encryptWithBase64PublicKey(publicKey, dob);
      
      //  console.log('Encrypted Name:', encryptedName);
      //  console.log('Encrypted DOB:', encryptedDob);
      
        return {
          earthId,
          issuerName: "EarthID",
          name: name,
          dateOfBirth: dob
        };
      };

    const storeVCToBank = async (vc) => {
        const payload = {
            company: name,
            type: "AgeCertificate",
            vc,
        };

        const config = {
            method: 'post',
            url: 'https://bankdb.myearth.id/api/vcnew/store',
            headers: { 'Content-Type': 'application/json' },
            data: JSON.stringify(payload)
        };

        const response = await axios.request(config);
        const vcID = response.data.vcId;
        return `https://bankdb.myearth.id/api/vcnew/${vcID}`;
    };

    const handleSubmit = async () => {
        Swal.fire({
            title: 'Generating Proof of Age...',
            text: 'Please wait while we generate your verifiable credential.',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        setLoading(true);
        try {
           // const vc = await generateAgeProof(dob, name);
           const certificate = await generateAgeCertificate()
            const vcURL = await storeVCToBank(certificate);
            if (isMounted.current) {
                setVcUrl(vcURL);
                setLoading(false);
            }

            Swal.fire({
                icon: 'success',
                title: 'Proof Generated',
                text: 'Your verifiable credential has been stored and a QR code has been generated.',
            });
        } catch (err) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: 'Generation Failed',
                text: 'Something went wrong while generating your proof of age.',
            });
        }
    };

    return (
        <div className="container">
            <div className="wrapper">
                <div className="left-pane">
                    <h3>Age Proof Generation</h3>
                    <div className="input-container">
                        {!isLoggedIn && (
                            <>
                                <p>🔐 Please login to continue</p>
                                <Login onComplete={handleLoginFlowComplete} />
                            </>
                        )}

                        {isLoggedIn && (
                            <>
                                <label>Name</label>
                                <input
                                    type="text"
                                    placeholder="Enter Full Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />

                                <label>Date of Birth</label>
                                <input
                                    type="date"
                                    value={dob}
                                    onChange={(e) => setDob(e.target.value)}
                                />

                                <button
                                    onClick={handleSubmit}
                                    disabled={loading || !name || !dob}
                                >
                                    {loading ? 'Generating...' : 'Generate Proof'}
                                </button>
                            </>
                        )}
                    </div>
                </div>

                <div className="linee"></div>

                <div className="right-pane">
                    <h3>Verifiable Credential QR</h3>
                    {vcUrl && (
                        <div className="response-container">
                            <QRCode value={vcUrl} size={220} level="H" includeMargin={true} />
                            <p style={{ marginTop: '10px' }}>
                                <a href={vcUrl} target="_blank" rel="noopener noreferrer">
                                    View Verifiable Credential
                                </a>
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};


export default AgeProofForm;
